import { ReactComponent as LogoSVG } from '../assets/Logo.svg';

export const ArloLogo = (props: any) =>
  <LogoSVG viewBox="0 0 480 168" {...props} />
